<template>
  <ul
    :class="`rating rating--size-${size}`"
    @touchmove="touchMoveHandler"
    @touchend="setStar(hoverStar)"
  >
    <li
      class="cursor-pointer"
      v-for="star in maxStars"
      :key="star"
      @mouseover="setHoverStar(star)"
      @mouseleave="unsetHoverStar"
      @click="setStar(star)"
    >
      <img
        :src="$asset(`img/common/stars/${starColor}/${starType(star)}-star.svg`)"
        :alt="$t(`messages_nl.includes.rating.${starType(star)}Star`)"
        class="filter-grey-outline"
        loading="lazy"
      >
      <input type="hidden">
    </li>
  </ul>
</template>

<script>
export default {
  name: "adivare-review-stars",
  emits: [
    'update:modelValue',
    'starClicked',
  ],
  props: {
    maxStars: {
      type: Number,
      required: false,
      default: 5,
    },
    defaultRating: {
      type: Number,
      required: false,
      default: 3,
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'md',
      validator: (value) => {
        return [
          '2xs',
          'xs',
          'sm',
          'md',
          'lg',
          'xl',
        ].includes(value);
      }
    },
  },
  data() {
    return {
      storedRating: null,
      hoverStar: false,
      starColors: {
        '1': 'red',
        '1.5': 'red',
        '2': 'orange',
        '2.5': 'orange',
        '3': 'yellow',
        '3.5': 'yellow',
        '4': 'light-green',
        '4.5': 'green',
        '5': 'green',
      }
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.storedRating ?? Math.round(this.defaultRating);
      },
      set(value) {
        this.storedRating = value;
        this.$emit('update:modelValue', value);
      }
    },
    starColor() {
      if (false !== this.hoverStar && this.hoverStar in this.starColors) {
        return this.starColors[this.hoverStar];
      }

      if (this.modelValue in this.starColors) {
        return this.starColors[this.modelValue];
      }

      return 'default';
    },
  },
  methods: {
    setStar(star) {
      if (true === this.readOnly || false === star) return;

      this.modelValue = star;
      this.$emit('starClicked');
    },
    setHoverStar(star) {
      if (true === this.readOnly) return;

      this.hoverStar = star;
    },
    unsetHoverStar() {
      if (true === this.readOnly) return;

      this.hoverStar = false;
    },
    starType(star) {
      return star <= (false !== this.hoverStar ? this.hoverStar : this.modelValue) ? 'full' : 'empty';
    },
    touchMoveHandler(event) {

      // touch position
      const touchPosition = event.targetTouches[0].clientX;

      // never allow a negative number. This normally occurs when touch position is left from element.
      const minRange = Math.max(0, touchPosition - this.$el.offsetLeft) || 0.1;

      // never allow a negative number or a number larger than width of element
      const minMaxRange = Math.min(this.$el.clientWidth, minRange) || this.$el.clientWidth;

      // set total stars
      const stars = Math.ceil(minMaxRange / (this.$el.clientWidth / this.maxStars));

      this.setHoverStar(stars);
    }
  },
}
</script>
